<template>
    <div class="form-submit">
        <div>
            <router-link v-if="routeAfterCancelLink" :to="routeAfterCancelLink">{{ t('general.cancel') }}</router-link>
        </div>
        <button
            type="submit"
            class="button button--rounded"
            :disabled="disabled"
        >
            {{ buttonLabel }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'FormSubmit',

    props: {
        routeAfterCancelLink: {
            type: Object,
            required: false,
            default: null,
        },

        buttonLabel: {
            type: String,
            required: true,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.form-submit {
    display: flex;
    align-items: center;

    div {
        flex: 2;

        a {
            color: $yellow;
            text-decoration: none;
            display: inline;
        }
    }

    button {
        flex: 6;
        width: 100%;
    }
}
</style>
